import React from "react";
import { Star } from "lucide-react";
import { REVIEWS, CLINIC } from "../lib/data";
import { Reveal } from "./Reveal";

export function Stars({ count = 5, className = "h-4 w-4" }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <Star key={i} className={`${className} fill-amber-400 text-amber-400`} />
      ))}
    </div>
  );
}

export function ReviewsSection() {
  return (
    <section className="py-20 sm:py-28 bg-offwhite" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12">
            <div>
              <span className="text-xs font-bold tracking-[0.2em] uppercase text-navy">Reviews</span>
              <h2 className="mt-3 font-display text-3xl sm:text-4xl font-semibold text-text-dark tracking-tight">
                Loved by our patients
              </h2>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-display text-4xl font-bold text-navy">{CLINIC.rating.toFixed(1)}</span>
              <div>
                <Stars />
                <span className="text-sm text-text-muted">Google Reviews</span>
              </div>
            </div>
          </div>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.08}>
              <div className="h-full bg-white rounded-3xl p-7 border border-border-light card-hover" data-testid={`review-card-${i}`}>
                <Stars />
                <p className="mt-4 text-text-muted leading-relaxed">{r.text}</p>
                <div className="mt-6 flex items-center justify-between">
                  <span className="font-semibold text-text-dark">{r.name}</span>
                  <span className="text-sm text-text-muted">{r.date}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export function GoogleMap({ className = "" }) {
  return (
    <div className={`overflow-hidden rounded-3xl border border-border-light ${className}`} data-testid="google-map">
      <iframe
        title="Arena Movement Physiotherapy location"
        src="https://www.google.com/maps?q=1A%20Sydenham%20Street%2C%20Sandringham%20VIC%203191&output=embed"
        width="100%"
        height="100%"
        style={{ border: 0, minHeight: 320 }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}

export function HoursTable() {
  return (
    <div className="bg-white rounded-3xl border border-border-light p-7" data-testid="hours-table">
      <h3 className="font-display text-xl font-semibold text-text-dark">Opening Hours</h3>
      <p className="mt-1 text-sm text-text-muted">Physio consultations currently Mondays only.</p>
      <ul className="mt-5 divide-y divide-border-light">
        {CLINIC.hours.map((h) => (
          <li key={h.day} className="flex justify-between py-2.5 text-sm">
            <span className="font-medium text-text-dark">{h.day}</span>
            <span className={h.open ? "text-navy font-semibold" : "text-text-muted"}>{h.time}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
